/*--------------------------------------------------------------
[ ### Start Import ]
--------------------------------------------------------------*/
import { createRouter, createWebHistory } from 'vue-router'
import master from '../views/Master.vue'
import Welcome from '../views/Welcome.vue'
import ServerSetupRequirements from '../views/ServerSetupRequirements.vue'
import ServerConfiguration from '../views/ServerConfiguration.vue'
import AdminPanelSetup from '../views/AdminPanelSetup.vue'
import FlutterEnvironmentSetup from '../views/FlutterEnvironmentSetup.vue'
import AppInstallation from '../views/AppInstallation.vue'
import DevelopmentAndTesting from '../views/DevelopmentAndTesting.vue'
import AndroidAppDeployment from '../views/AndroidAppDeployment.vue'
import iOSAppDeployment from '../views/iOSAppDeployment.vue'
import WebsiteVersionUpdate from '../views/WebsiteVersionUpdate.vue'
import AppVersionUpdate from '../views/AppVersionUpdate.vue'
/*--------------------------------------------------------------
[ ### End Import ]
--------------------------------------------------------------*/


const routes = [
/*--------------------------------------------------------------
  [ ### Start Path ]
--------------------------------------------------------------*/
  {
    path: '/',
    component: master,
    children: [
      {
        path: '',
        name: 'Welcome',
        component: Welcome,
      },
      {
        path: 'server-setup-requirements',
        name: 'ServerSetupRequirements',
        component: ServerSetupRequirements,
      },
      {
        path: 'server-configuration',
        name: 'ServerConfiguration',
        component: ServerConfiguration,
      },
      {
        path: 'admin-panel-setup',
        name: 'AdminPanelSetup',
        component: AdminPanelSetup,
      },
      {
        path: 'flutter-environment-setup',
        name: 'FlutterEnvironmentSetup',
        component: FlutterEnvironmentSetup,
      },
      {
        path: 'app-installation',
        name: 'AppInstallation',
        component: AppInstallation,
      },
      {
        path: 'development-and-testing',
        name: 'DevelopmentAndTesting',
        component: DevelopmentAndTesting,
      },
      {
        path: 'android-app-deployment',
        name: 'AndroidAppDeployment',
        component: AndroidAppDeployment,
      },
      {
        path: 'ios-app-deployment',
        name: 'iOSAppDeployment',
        component: iOSAppDeployment,
      },
      {
        path: 'website-version-update',
        name: 'WebsiteVersionUpdate',
        component: WebsiteVersionUpdate,
      },
      {
        path: 'app-version-update',
        name: 'AppVersionUpdate',
        component: AppVersionUpdate,
      },
    ],
  }
/*--------------------------------------------------------------
  [ ### End Path ]
--------------------------------------------------------------*/
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return{ top: 0 }
  }
})


router.beforeEach((to, from, next) => {
  console.log(to)
  document.title = `${ process.env.VUE_APP_TITLE } - ${ to.name }`
  next()
})

export default router
